"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesService = void 0;
const _ = __importStar(require("lodash"));
const config_1 = require("../config/config");
const games_1 = require("../models/games");
const types_1 = require("../models/games/types");
const ticket_1 = require("../models/ticket");
const types_2 = require("../models/ticket/types");
const api_1 = require("./api");
const PATH = 'game/api';
const PATH_V1 = 'game/api/v1';
const PATH_V2 = 'game/api/v2';
const PLAYER_PATH = 'game/player/api';
class GamesService {
    static async getFeaturedGame(gameType, sort, filter) {
        const sortCondition = sort === '' ? '&sort=lastModifiedDate,desc' : sort;
        const filterCondition = !!filter ? filter : '';
        const type = !!gameType || !!config_1.react_core_config.internalConfig.showGameTypeFilter
            ? gameType
            : config_1.react_core_config.internalConfig.instantGameType;
        const url = `${PATH}/published-games?gameTypeId.in=${type}${filterCondition}&page=0&size=1${sortCondition}`;
        try {
            const response = await api_1.API.get({ url });
            let parsedGame = {};
            if (response.content && response.content.length) {
                parsedGame = games_1.Game.JsonToGame(response.content[0]);
            }
            return {
                parsedGame
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getPublishedGames(page, size, sort, filter, type, excludeFeature, includeExpired) {
        const gameType = !!type || !!config_1.react_core_config.internalConfig.showGameTypeFilter
            ? type
            : config_1.react_core_config.internalConfig.instantGameType;
        let requestParams = ``;
        const doFilter = excludeFeature !== undefined
            ? !excludeFeature
            : filter !== null && filter !== undefined && filter.length > 0;
        if (page) {
            requestParams = `page=${page}&` + requestParams;
        }
        if (size) {
            requestParams = `size=${size}&` + requestParams;
        }
        requestParams = sort
            ? `sort=${sort}&excludeFeatured=${!doFilter}&` + requestParams
            : sort === ''
                ? `excludeFeatured=${!doFilter}&` + requestParams
                : `sort=lastModifiedDate,desc&excludeFeatured=${!doFilter}&` + requestParams;
        let url;
        if (doFilter) {
            requestParams = `${filter}&` + requestParams;
            url = `${PATH}/published-games?${requestParams}`;
            if (!url.includes('gameTypeId.in=')) {
                url = `${PATH}/published-games?gameTypeId.in=${gameType}&${requestParams}`;
            }
        }
        else {
            url = `${PATH}/published-games?gameTypeId.in=${gameType}&${requestParams}`;
        }
        if (includeExpired) {
            url += 'includeExpired.equals=true';
        }
        try {
            const response = await api_1.API.get({ url });
            const parsedGames = games_1.Game.JsonToGames(response.content);
            const last = doFilter
                ? response.last
                : Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
            const totalPages = doFilter
                ? response.totalPages
                : Math.ceil((response.totalElements - 1) / response.size);
            return {
                parsedGames,
                page: {
                    first: response.first,
                    last,
                    totalElements: response.totalElements,
                    totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getPublishedGamesByIds(ids) {
        const url = `${PATH}/published-games?id.in=${ids}`;
        try {
            const response = await api_1.API.get({ url });
            const parsedGames = games_1.Game.JsonToGames(response.content);
            return {
                parsedGames,
                page: {
                    first: response.first,
                    last: response.last,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getPublishedGamesByGameIds(ids) {
        const url = `${PATH}/published-games?gameId.in=${ids}`;
        try {
            const response = await api_1.API.get({ url });
            const parsedGames = games_1.Game.JsonToGames(response.content);
            return parsedGames;
        }
        catch (error) {
            throw error;
        }
    }
    static async getGameRetailPrices() {
        const requestUrl = `${PATH}/published-games/price-points`;
        try {
            const response = await api_1.API.get({
                url: requestUrl
            });
            return response;
        }
        catch (error) {
            throw error;
        }
    }
    static async getGameTypes() {
        const requestUrl = `${PATH}/game-types`;
        try {
            const response = await api_1.API.get({
                url: requestUrl
            });
            return response;
        }
        catch (error) {
            throw error;
        }
    }
    static async getGameTagTypes() {
        const requestUrl = `${PATH}/game-tag-types`;
        try {
            const response = await api_1.API.get({
                url: requestUrl
            });
            return response;
        }
        catch (error) {
            throw error;
        }
    }
    static async getGameTags() {
        const requestUrl = `${PATH}/game-tags`;
        try {
            const response = await api_1.API.get({
                url: requestUrl
            });
            return response;
        }
        catch (error) {
            throw error;
        }
    }
    static async getPublishedGame(id, includeExpired) {
        try {
            const response = await api_1.API.get({
                url: includeExpired
                    ? `${PATH}/published-games/${id}/include-expired`
                    : `${PATH}/published-games/${id}`
            });
            return games_1.Game.JsonToGame(response);
        }
        catch (error) {
            throw error;
        }
    }
    static async getPrizesForGame(gameId) {
        try {
            return await api_1.API.get({
                url: `${PATH}/published-games/${gameId}/prizes`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async enterTicket(ticketNumber, validationCode) {
        try {
            const body = validationCode ? { ticketNumber, validationCode } : { ticketNumber };
            return await api_1.API.post({
                url: `${PATH}/ticket-entries/manual`,
                body
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async enterTicketBarCode(ticketBarCode) {
        try {
            return await api_1.API.post({
                url: `${PATH}/ticket-entries/scan`,
                body: {
                    ticketBarCode
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async enterTicketV2(ticketNumber, validationCode) {
        try {
            const body = validationCode ? { ticketNumber, validationCode } : { ticketNumber };
            return await api_1.API.post({
                url: `${PATH}/v2/ticket-entries/manual`,
                body
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async enterTicketBarCodeV2(ticketBarCode) {
        try {
            return await api_1.API.post({
                url: `${PATH}/v2/ticket-entries/scan`,
                body: {
                    ticketBarCode
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkInstantTicketBarCode(barcode) {
        try {
            return await api_1.API.post({
                url: `${PATH}/ticket/check-instant`,
                body: {
                    barcode
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkDrawTicketBarCode(barcode) {
        try {
            return await api_1.API.post({
                url: `${PATH}/ticket/check-draw`,
                body: {
                    barcode
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkCashOnlineBarCode(barcode) {
        try {
            return await api_1.API.post({
                url: `${PATH}/ticket/check-cash-online`,
                body: {
                    barcode
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async checkCashInstantBarCode(barcode) {
        try {
            return await api_1.API.post({
                url: `${PATH}/ticket/check-cash-instant`,
                body: {
                    barcode
                }
            }).then(response => response);
        }
        catch (error) {
            throw error;
        }
    }
    static async getDrawsForGame(gameId, size, page, sort) {
        let requestParams = `size=${size}&`;
        if (page) {
            requestParams = `page=${page}&` + requestParams;
        }
        requestParams = sort
            ? `sort=${sort}&` + requestParams
            : `sort=end,desc&sort=name,asc&` + requestParams;
        const url = `${PATH}/published-games/${gameId}/draws?${requestParams}`;
        try {
            return await api_1.API.get({
                url
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getPromotionsForGame(gameId, size, page, sort) {
        let requestParams = `size=${size}&`;
        if (page) {
            requestParams = `page=${page}&` + requestParams;
        }
        requestParams = sort
            ? `sort=${sort}&` + requestParams
            : `sort=end,desc&sort=name,asc&` + requestParams;
        const url = `${PLAYER_PATH}/games/${gameId}/promotions?${requestParams}`;
        try {
            const response = await api_1.API.get({
                url
            });
            const last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
            const totalPages = Math.ceil((response.totalElements - 1) / response.size);
            return {
                content: response.content,
                page: {
                    first: response.first,
                    last,
                    totalElements: response.totalElements,
                    totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getActiveDrawsForGame(gameId) {
        try {
            return await api_1.API.get({
                url: `${PLAYER_PATH}/games/${gameId}/draws`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getAllDrawIdsForGame(gameId) {
        try {
            return await api_1.API.get({
                url: `${PLAYER_PATH}/games/${gameId}/draw-ids`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getDrawIdsPerGame(gameId) {
        try {
            return await api_1.API.get({
                url: `${PLAYER_PATH}/games/${gameId}/draws/ids`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getSecondChanceEligibleGames() {
        try {
            return await api_1.API.get({
                url: `${PLAYER_PATH}/eligible-games`
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getRelatedGames(gameId, numOfGames) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/published-games/${gameId}/related-games/${numOfGames}`
            });
            return games_1.Game.JsonToRelatedGames(response);
        }
        catch (error) {
            throw error;
        }
    }
    static async getAllRelatedGames(gameId) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/published-games/${gameId}/related-games`
            });
            return games_1.Game.JsonToRelatedGames(response);
        }
        catch (error) {
            throw error;
        }
    }
    static async getEligibleGamesForDraw(drawId) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/draws/${drawId}/games`
            });
            return games_1.Game.JsonToGames(response);
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchDrawsByIdsForTicket(ticketSubmissionPrizeDTOs) {
        try {
            let ids = [];
            if (ticketSubmissionPrizeDTOs && ticketSubmissionPrizeDTOs.length) {
                ids = ticketSubmissionPrizeDTOs
                    .filter(plb => plb.prizeType === types_2.PrizeType.ENTRY)
                    .map(p => p.externalId);
            }
            const ticketSubmissionPrizeDTOList = new ticket_1.TicketSubmissionPrizeDTOList();
            if (ids.length > 0) {
                const requestParams = ids.join(',');
                const response = await api_1.API.get({
                    url: `${PATH}/draws-by-ids?ids=${requestParams}`
                });
                if (response) {
                    ticketSubmissionPrizeDTOs.forEach((prize, index) => {
                        var _a;
                        prize.promotionId = (_a = response[index]) === null || _a === void 0 ? void 0 : _a.promotionId;
                        ticketSubmissionPrizeDTOList.push(prize);
                    });
                }
            }
            return ticketSubmissionPrizeDTOList;
        }
        catch (e) {
            throw e;
        }
    }
    static async getGamesByIds(ids) {
        const url = `${PATH}/games-by-ids?ids=${ids}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async getGameConfig(gameId) {
        try {
            return await api_1.API.get({
                url: `${PATH}/interactive/${gameId}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async updateGame(id) {
        try {
            return await api_1.API.put({
                url: `${PATH}/interactive/${id}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getLatestJackpotResultByGame(id) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/jackpot/${id}`
            });
            if (response) {
                return Object.assign(Object.assign({}, response), { gameNumbers: this.convertResultDataForKeno(response.resultData) });
            }
            else {
                return {
                    jackpotResult: null,
                    resultData: [],
                    gameNumbers: []
                };
            }
        }
        catch (error) {
            throw error;
        }
    }
    static async getJackpotResultByGameAndDraw(gameId, drawId) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/jackpot/${gameId}/${drawId}`
            });
            if (response) {
                return Object.assign(Object.assign({}, response), { gameNumbers: this.convertResultDataForKeno(response.resultData), currentDraw: drawId });
            }
            else {
                return {
                    jackpotResult: null,
                    resultData: [],
                    gameNumbers: [],
                    currentDraw: drawId
                };
            }
        }
        catch (error) {
            throw error;
        }
    }
    static async sendPlayerTicketDataForJackpotGame(gameId, drawId, playerSpots, ticketCost) {
        try {
            const response = await api_1.API.post({
                url: `${PATH}/jackpot/${gameId}/${drawId}`,
                body: {
                    ticketCost,
                    playerSpots: playerSpots.join(',')
                }
            });
            return Object.assign(Object.assign({}, response), { gameNumbers: this.convertResultDataForKeno(response.resultData) });
        }
        catch (error) {
            throw error;
        }
    }
    static async getMultipleDrawsPayout(gameId, drawIds, playerSpots, ticketCost) {
        try {
            const response = await api_1.API.post({
                url: `${PATH}/jackpot/${gameId}`,
                body: {
                    ticketCost,
                    playerSpots: playerSpots.join(','),
                    drawNumbers: drawIds
                }
            });
            let tempResponse = [];
            if (response) {
                tempResponse = response.map((item) => {
                    item.gameNumbers = this.convertResultDataForKeno(item.resultData);
                    return item;
                });
            }
            return tempResponse;
        }
        catch (error) {
            throw error;
        }
    }
    static async getLatestJackpotResult(gameId, status, version) {
        const basePath = version === 'v1' ? PATH_V1 : PATH_V2;
        const url = `${basePath}/jackpot-results/${gameId}/${types_1.IJackpotStatus[status]}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (e) {
            throw e;
        }
    }
    static async getLatestJackpotResultByStatus(gameId, status) {
        return this.getLatestJackpotResult(gameId, status, 'v1');
    }
    static async getLatestJackpotResultByStatusV2(gameId, status) {
        return this.getLatestJackpotResult(gameId, status, 'v2');
    }
    static async getFastPlayJackpotAmount() {
        try {
            return await api_1.API.get({
                url: `${PATH_V1}/fastplay/jackpot-amount`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getGameUnclaimedPrizesByGameTypes(gameTypes) {
        try {
            return await api_1.API.get({
                url: `${PATH}/game/prizes/unclaimed?gameTypeIds=${gameTypes.join(',')}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getGameUnclaimedPrizesByGameId(gameId, page, size) {
        try {
            return await api_1.API.get({
                url: `${PATH}/game/${gameId}/prizes/unclaimed?page=${page || 0}&size=${size || 9999}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getJackpotResults(gameId, status, version, page = 0, size = 9999) {
        const basePath = version === 'v1' ? PATH_V1 : PATH_V2;
        const url = version === 'v1'
            ? `${basePath}/jackpot-results?gameId.equals=${gameId}&jackpotStatus.equals=${types_1.IJackpotStatus[status]}&page=${page}&size=${size}&sort=drawDate,desc`
            : `${basePath}/jackpot-results?gameId=${gameId}&jackpotStatus=${types_1.IJackpotStatus[status]}&page=${page}&size=${size}&sort=drawDate,desc`;
        try {
            const response = await api_1.API.get({ url });
            const last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
            const totalPages = Math.ceil((response.totalElements - 1) / response.size);
            const recentDraw = response.content && response.content.length > 0 ? response.content[0] : {};
            return {
                recentDraw,
                content: response.content,
                page: {
                    first: response.first,
                    last,
                    totalElements: response.totalElements,
                    totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getJackpotResultsForTheGameV2(gameId, status, page, size) {
        return this.getJackpotResults(gameId, status, 'v2', page, size);
    }
    static async getJackpotResultsForTheGame(gameId, status, page, size) {
        return this.getJackpotResults(gameId, status, 'v1', page, size);
    }
    static async getExternalGameId(gameId, providerId) {
        try {
            return await api_1.API.get({
                url: `${PATH}/game-provider-mappings/${gameId}/${providerId}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getInternalGameId(ids, provider) {
        try {
            return await api_1.API.get({
                url: `${PATH}/games/provider/${provider}`,
                query: {
                    ids: ids.join(',')
                }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static convertResultDataForKeno(resultData) {
        const sorted = _.orderBy(resultData, ['order']).filter(item => item.type === types_1.IJackpotGameResultDataType[types_1.IJackpotGameResultDataType.REGULAR]);
        return _.map(sorted, 'data').map(item => parseInt(item, 10));
    }
    static async fetchGameIdsByGameType(gameTypeId) {
        const url = `${PATH}/game-by-gametype/${gameTypeId}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.GamesService = GamesService;
//# sourceMappingURL=games-service.js.map